// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"e4e086dd","241":"761d5f4f","877":"a7d09ca2"}[chunkId] + ".chunk.css";
};